import { AuthException } from "./auth.exception";

export class IncorrectPasswordException extends AuthException {
  constructor() {
    super("errors.auth.incorrect.password", "Incorrect password");
  }
}
